import { render, staticRenderFns } from "./ManagerCampsRegistry.vue?vue&type=template&id=9b475848&lang=pug&"
import script from "./ManagerCampsRegistry.vue?vue&type=script&lang=js&"
export * from "./ManagerCampsRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports